document.addEventListener('DOMContentLoaded', function() {
    const searchDialog = {
        currentDialog: undefined,
        lastFocus: undefined,
    }
    const searchToggle = document.querySelectorAll('.search-display');

    if (!searchToggle.length) {
        return;
    }

    searchToggle.forEach(function (toggleButton) {
        toggleButton.addEventListener('click', (e) => {
            toggleButton.toggleAttribute('aria-expanded', true);
            if (toggleButton.getAttribute('aria-expanded') === 'true') {
                toggleButton.setAttribute('aria-expanded', 'false');
                searchDialog.currentDialog = null;
                document.removeEventListener('keydown', escapeHandle);
                document.removeEventListener('focus', trapFocus, true);
                document.body.classList.remove('search-open');
            } else {
                const input = toggleButton.nextElementSibling.querySelector('input');
                toggleButton.setAttribute('aria-expanded', 'true');
                searchDialog.currentDialog = toggleButton;
                document.addEventListener('keydown', escapeHandle);
                input.focus();
                document.activeElement = input;
                searchDialog.lastFocus = document.activeElement;
                document.addEventListener('focus', trapFocus, true);
                document.body.classList.add('search-open');
                jQuery("ul#mega-menu-main_menu").data('maxmegamenu').hideMobileMenu();
            }
        });
    });

    jQuery("ul#mega-menu-main_menu").on("mmm:showMobileMenu", function() {
        if (searchDialog.currentDialog) {
            searchDialog.currentDialog.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('search-open');
        }
    });

    function escapeHandle(e) {
        if (e.key === 'Escape') {
            searchDialog.currentDialog.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('search-open');
            searchDialog.currentDialog.focus();
            document.removeEventListener('keydown', escapeHandle);
            document.removeEventListener('focus', trapFocus, true);
        }
    }

    function trapFocus(event) {
        event.stopPropagation();

        const firstElement = searchDialog.currentDialog.nextElementSibling.querySelector('input');
        const lastElement = searchDialog.currentDialog.nextElementSibling.querySelector('button');

        if (!searchDialog.lastFocus) {
            searchDialog.lastFocus = firstElement;
        } else if (searchDialog.lastFocus === lastElement) {
            firstElement.focus();
            document.activeElement = firstElement;
            searchDialog.lastFocus = firstElement;
        } else {
            searchDialog.lastFocus = document.activeElement;
        }
    }
});
